module.exports = __webpack_public_path__ + "media/images/application2/AppTipsIndex__dl__item__balloon-a61c86f75e3e349e50ce8be661af24fd.svg";